import React, { useEffect, useState, useRef } from 'react';
import Logo from '../assets/hsulogo.svg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { IoMdDownload } from "react-icons/io";
import UserManual from '../utilities/User_Manual.pdf';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import LeafletMap from './LeafletMap';
import { MdFileUpload } from "react-icons/md";


const Home = () => {

  const targetRef = useRef(null);
  const [sensorDataQueue, setSensorDataQueue] = useState({
    temperature: [],
    pressure: [],
    altitude: [],
    accelerationX: [],
    accelerationY: [],
    accelerationZ: [],
    gyroX: [],
    gyroY: [],
    gyroZ: [],
    latitude: [],
    longitude: [],
    humidity: [],
    battery: [],
    current: [],
    magneticX: [],
    magneticY: [],
    magneticZ: [],
    uv: []
});
const [time, setTime] = useState(0);
useEffect(() => {
    // Increment the time counter when new data is added
    if (sensorDataQueue.temperature.length > 0) {
        setTime((prevTime) => prevTime + 1);
    }
}, [sensorDataQueue.temperature]);


// Function to update the queue with new data
const updateQueue = (queue, newData) => {
    if (queue.length === 10) {
        queue.shift(); // Remove oldest data if queue is full
    }
    return [...queue, newData]; // Add new data to the end of the queue
};


// Combine acce data for all axes into one dataset
const combinedAccelerationData = sensorDataQueue.accelerationX.map((valueX, index) => ({
    time: time - sensorDataQueue.accelerationX.length + index + 1,
    gyroX: valueX,
    gyroY: sensorDataQueue.accelerationY[index],
    gyroZ: sensorDataQueue.accelerationZ[index]
}));


// Combine gyro data for all axes into one dataset
const combinedGyroData = sensorDataQueue.gyroX.map((valueX, index) => ({
    time: time - sensorDataQueue.gyroX.length + index + 1,
    accelerationX: valueX,
    accelerationY: sensorDataQueue.gyroY[index],
    accelerationZ: sensorDataQueue.gyroZ[index]
}));

//combined magnetic field data for all axes into one dataset
const combinedMagneticFiledData = sensorDataQueue.magneticX.map((valueX, index) => ({
    time: time - sensorDataQueue.magneticX.length + index + 1,
    magneticX: valueX,
    magneticY: sensorDataQueue.magneticY[index],
    magneticZ: sensorDataQueue.magneticZ[index]
}))



const handelShowPorts = async (event) => {
    try {

        // Open file picker for .txt file
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = '.txt';

        fileInput.onchange = async (e) => {
            const file = e.target.files[0];

            if (!file) {
                toast.error('No file selected!');
                return;
            }

            try {
                const fileContent = await file.text();

                const lines = fileContent.split('\n');

                // Define the sensor types to process
                const sensorTypes = [
                    'temperature',
                    'pressure',
                    'altitude',
                    'accelerationX',
                    'accelerationY',
                    'accelerationZ',
                    'gyroX',
                    'gyroY',
                    'gyroZ',
                    'latitude',
                    'longitude',
                    'humidity'
                ];

                for (const line of lines) {
                    if (line.trim() === '') continue; // Skip empty lines

                    console.log('Processing line:', line); // Log the line to the console

                    const sensorValues = line.split(',').map((value) => parseFloat(value.trim()));

                    // Update the sensorDataQueue state with the new data
                    setSensorDataQueue((prevQueue) => {
                        const updatedQueue = { ...prevQueue };
                        sensorTypes.forEach((type, index) => {
                            updatedQueue[type] = updateQueue(prevQueue[type], sensorValues[index]);
                        });

                        if (targetRef.current) {
                            targetRef.current.scrollIntoView({ behavior: 'smooth' });
                        }

                        return updatedQueue;
                    });

                    // Add a delay of 1 second before processing the next line
                    await new Promise((resolve) => setTimeout(resolve, 1000));
                }

                toast.success('Data successfully processed from file!');
            } catch (error) {
                console.error('Error reading file:', error);
                toast.error('Failed to read data from the file.');
            }
        };

        fileInput.click(); // Trigger the file picker dialog

    } catch (error) {
        console.error('Error handling file:', error);
        toast.error('An unexpected error occurred.');
    }
};

  

  const handelDownload = () => {
    const link = document.createElement('a');
    link.href = UserManual;

    link.download = 'DashboardUserManual.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  }

  return (
    <div className='h-full flex flex-col justify-center items-center bg-stone-900 gap-12'>
      <ToastContainer theme='dark' />
      <div className='flex gap-[72rem] items-center mt-0 absolute top-0 w-full h-18 '>
        <a href="https://hexstaruniverse.com"><img src={Logo} alt="Xexicon" className='m-4 w-[125px] cursor-pointer'/></a>
        <button className='flex justify-center h-8 items-center gap-2 bg-[#6637ed] rounded-md text-white font-["Poppins"] capitalize px-3 shadow-sm shadow-white/40 shadow-opacity-10 hover:bg-purple-700' onClick={handelDownload}>
          <IoMdDownload color='white' size={20}></IoMdDownload>
          user manual
        </button>
      </div>
      

        <button className='capitalize bg-[#6637ed] font-normal text-lg text-white px-3 rounded-md py-1 font-["Poppins"] shadow-sm shadow-white/40 shadow-opacity-10 hover:bg-purple-700 mt-16  cursor-pointer flex justify-center items-center gap-2' onClick={handelShowPorts}>Upload file <MdFileUpload /></button>

        {/* <motion.div className='w-[500px] mt-12' animate={animation}>
          <img src={globe} alt="Earth" />
        </motion.div> */}


        <div className='bg-dashboard flex justify-center items-baseline w-full font-["Aldrich"] text-white gap-20 py-20'>
            <div className='flex flex-col gap-5' ref={targetRef}>
            <div className='flex flex-col gap-4 text-xs'  id='content'>
                <button className='uppercase bg-[#6637ed] rounded-md px-3 py-2 hover:bg-purple-700 transition-[0.3s]' onClick={() => window.location.href = 'https://wa.link/e1vw9c'}>support</button>
                <button className='uppercase bg-[#6637ed] rounded-md px-3 py-2 hover:bg-purple-700 transition-[0.3s]' onClick={() => window.location.href = 'https://dashboard.cubesat.in/'}>change version</button>

            </div>
            <div className='text-white text-xs'>
                <ul className='flex flex-col gap-2'>
                    <li className='flex gap-2 capitalize'>
                        <div className='w-[18px] h-[18px] bg-[#4cfe53] rounded-sm'>

                        </div>
                        <p>X axis data</p>
                    </li>
                    <li className='flex gap-2 capitalize'>
                        <div className='w-[18px] h-[18px] bg-[#fe4c4c] rounded-sm'>

                        </div>
                        <p>Y axis data</p>
                    </li>
                    <li className='flex gap-2 capitalize'>
                        <div className='w-[18px] h-[18px] bg-[#0076ff] rounded-sm'>

                        </div>
                        <p>Z axis data</p>
                    </li>
                </ul>
            </div>
            </div>
            
            {/* Display sensor data */}
            <div className='flex flex-col gap-6 mt-7'>
            <div className='flex flex-row gap-12'>
            {/* Temperature Chart */}
            <div className='flex flex-col py-4 bg-[#121212] bg-opacity-60 rounded-[10px] shadow border border-[#6637ed] backdrop-blur-[10px] text-[10px] h-[185px]'>
                <p className='flex justify-center items-center font-normal text-[10px]'>Temperature</p>
                <LineChart
                    width={243}
                    height={142}
                    data={sensorDataQueue.temperature.map((temp, index) => ({
                        time: time - sensorDataQueue.temperature.length + index + 1,
                        temperature: temp
                    }))}
                    margin={{ right: 35, left: 10, top: 12 }}
                >
                    <XAxis dataKey="time" label={{ value: "Time", position: "outsideBottom", dy: 10 }} stroke='white' />
                    <YAxis label={{ value: "Celcius", angle: -90, position: "insideCenter", dx: -10 }} domain={[5, 55]} stroke='white' />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: '#121212',
                            borderColor: '#6637ed',
                            color: 'white',
                            borderRadius: 2
                        }}
                        itemStyle={{
                            color: '#FEF74C',
                        }}
                    />
                    <CartesianGrid stroke="#f5f5f5" strokeOpacity={0.1} />
                    <Line type='linear' dataKey="temperature" stroke="#FEF74C" strokeWidth={2} />
                </LineChart>
            </div>

            {/* Altitude Chart */}
            <div className='flex flex-col py-4 bg-[#121212] bg-opacity-60 rounded-[10px] shadow border border-[#6637ed] backdrop-blur-[10px] text-[10px] h-[185px]'>
                <p className='flex justify-center items-center font-normal text-[10px]'>Altitude</p>
                <LineChart
                    width={243}
                    height={142}
                    data={sensorDataQueue.altitude.map((alt, index) => ({
                        time: time - sensorDataQueue.altitude.length + index + 1,
                        altitude: alt
                    }))}
                    margin={{ right: 35, left: 10, top: 12 }}
                >
                    <XAxis dataKey="time" label={{ value: "Time", position: "outsideBottom", dy: 10 }} stroke='white' />
                    <YAxis label={{ value: "Meter(s)", angle: -90, position: "insideCenter", dx: -20 }} domain={[50, 80]} stroke='white' />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: '#121212',
                            borderColor: '#6637ed',
                            color: 'white',
                            borderRadius: 2
                        }}
                        itemStyle={{
                            color: '#FF11DF',
                        }}
                    />
                    <CartesianGrid stroke="#f5f5f5" strokeOpacity={0.1} />
                    <Line type='linear' dataKey="altitude" stroke="#FF11DF" strokeWidth={2} />
                </LineChart>
            </div>

            {/* Atmospheric Pressure Chart */}
            <div className='flex flex-col py-4 bg-[#121212] bg-opacity-60 rounded-[10px] shadow border border-[#6637ed] backdrop-blur-[10px] text-[10px] h-[185px]'>
                <p className='flex justify-center items-center font-normal text-[10px]'>Atmospheric Pressure</p>
                <LineChart
                    width={243}
                    height={142}
                    data={sensorDataQueue.pressure.map((psi, index) => ({
                        time: time - sensorDataQueue.pressure.length + index + 1,
                        pressure: psi
                    }))}
                    margin={{ right: 35, left: 10, top: 12 }}
                >
                    <XAxis dataKey="time" label={{ value: "Time", position: "outsideBottom", dy: 10 }} stroke='white' />
                    <YAxis label={{ value: "PSI", angle: -90, position: "insideCenter", dx: -20 }} domain={[1000, 50000]} stroke='white' />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: '#121212',
                            borderColor: '#6637ed',
                            color: 'white',
                            borderRadius: 2
                        }}
                        itemStyle={{
                            color: '#FEA14C',
                        }}
                    />
                    <CartesianGrid stroke="#f5f5f5" strokeOpacity={0.1} />
                    <Line type='linear' dataKey="pressure" stroke="#FEA14C" strokeWidth={2} />
                </LineChart>
            </div>
            <div className='flex flex-col py-4 bg-[#121212] bg-opacity-60 rounded-[10px] shadow border border-[#6637ed] backdrop-blur-[10px] text-[10px] h-[185px]'>
                <p className='flex justify-center items-center font-normal text-[10px]'>Humidity</p>
                <LineChart
                    width={243}
                    height={142}
                    data={sensorDataQueue.humidity.map((hum, index) => ({
                        time: time - sensorDataQueue.humidity.length + index + 1,
                        humidity: hum
                    }))}
                    margin={{ right: 35, left: 10, top: 12 }}
                >
                    <XAxis dataKey="time" label={{ value: "Time", position: "outsideBottom", dy: 10 }} stroke='white' />
                    <YAxis label={{ value: "Percentage", angle: -90, position: "insideCenter", dx: -10 }} domain={[0, 100]} stroke='white' />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: '#121212',
                            borderColor: '#6637ed',
                            color: 'white',
                            borderRadius: 2
                        }}
                        itemStyle={{
                            color: '#4C84FE', // Customize the humidity line color
                        }}
                    />
                    <CartesianGrid stroke="#f5f5f5" strokeOpacity={0.1} />
                    <Line type='linear' dataKey="humidity" stroke="#4C84FE" strokeWidth={2} />
                </LineChart>
            </div>

        </div>

                <div className='flex flex-row gap-12 mt-4'>
                            <div className='flex flex-col py-4 bg-[#121212] bg-opacity-60 rounded-[10px] shadow border border-[#6637ed] backdrop-blur-[10px] text-[10px] h-[185px]'>
                <p className='flex justify-center items-center font-normal text-[10px]'>Orientation (Gyro)</p>
                <LineChart
                    width={243}
                    height={142}
                    data={combinedAccelerationData}
                    margin={{ right: 35, left: 10, top: 12 }}
                >
                    <XAxis dataKey="time" label={{ value: "Time", position: "outsideBottom", dy: 10 }} stroke='white' />
                    <YAxis
                        label={{ value: "Acceleration (m/s²)", angle: -90, position: "insideCenter", dx: -20 }}
                        domain={[2200, 20000]}
                        stroke='white'
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: '#121212',
                            borderColor: '#6637ed',
                            color: 'white',
                            borderRadius: 2
                        }}
                        itemStyle={{
                            color: 'white',
                        }}
                    />
                    <CartesianGrid stroke="#f5f5f5" strokeOpacity={0.1} />
                    <Line type='linear' dataKey="gyroX" stroke="#4cfe53" strokeWidth={2} />
                    <Line type='linear' dataKey="gyroY" stroke="#fe4c4c" strokeWidth={2} />
                    <Line type='linear' dataKey="gyroZ" stroke="#0076ff" strokeWidth={2} />
                </LineChart>
            </div>

                {/* data telemetry */}
                <div className="flex justify-center items-center w-[534px] rounded-[5px] h-[185px] border border-[#6637ed] py-2 px-1">
                    {sensorDataQueue.latitude?.length > 0 && sensorDataQueue.longitude?.length > 0 ? (
                        <LeafletMap
                            longitudes={sensorDataQueue.longitude}
                            latitudes={sensorDataQueue.latitude}
                        />
                    ) : (
                        <p className='flex justify-center items-center text-[10px]'>Loading map...</p>
                    )}
                </div>


                <div className='flex flex-col py-4 bg-[#121212] bg-opacity-60 rounded-[10px] shadow border border-[#6637ed] backdrop-blur-[10px] text-[10px] h-[185px]'>
                    <p className='flex justify-center items-center font-normal text-[10px]'>Acceleration</p>
                    <LineChart
                        width={243}
                        height={142}
                        data={combinedGyroData}
                        margin={{ right: 35, left: 10, top: 12 }}
                    >
                        <XAxis dataKey="time" label={{ value: "Time", position: "outsideBottom", dy: 10 }} stroke='white' />
                        <YAxis
                            label={{ value: "Acceleration (m/s²)", angle: -90, position: "insideCenter", dx: -20 }}
                            domain={[-150, 20000]}
                            stroke='white'
                        />
                        <Tooltip
                            contentStyle={{
                                backgroundColor: '#121212',
                                borderColor: '#6637ed',
                                color: 'white',
                                borderRadius: 2
                            }}
                            itemStyle={{
                                color: 'white',
                            }}
                        />
                        <CartesianGrid stroke="#f5f5f5" strokeOpacity={0.1} />
                        <Line type='linear' dataKey="accelerationX" stroke="#4cfe53" strokeWidth={2} />
                        <Line type='linear' dataKey="accelerationY" stroke="#fe4c4c" strokeWidth={2} />
                        <Line type='linear' dataKey="accelerationZ" stroke="#0076ff" strokeWidth={2} />
                    </LineChart>
                </div>

                </div>
                <div className='flex flex-row gap-12 mt-4'>
                            <div className='flex flex-col py-4 bg-[#121212] bg-opacity-60 rounded-[10px] shadow border border-[#6637ed] backdrop-blur-[10px] text-[10px] h-[185px]'>
                <p className='flex justify-center items-center font-normal text-[10px]'>UV Radiation</p>
                <LineChart
                    width={243}
                    height={142}
                    data={sensorDataQueue.uv.map((uvValue, index) => ({
                        time: time - sensorDataQueue.uv.length + index + 1,
                        uv: uvValue
                    }))}
                    margin={{ right: 35, left: 10, top: 12 }}
                >
                    <XAxis dataKey="time" label={{ value: "Time", position: "outsideBottom", dy: 10 }} stroke='white' />
                    <YAxis label={{ value: "UV Index", angle: -90, position: "insideCenter", dx: -10 }} domain={[0, 15]} stroke='white' />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: '#121212',
                            borderColor: '#6637ed',
                            color: 'white',
                            borderRadius: 2
                        }}
                        itemStyle={{
                            color: '#FEA14C', // Customize the UV line color
                        }}
                    />
                    <CartesianGrid stroke="#f5f5f5" strokeOpacity={0.1} />
                    <Line type='linear' dataKey="uv" stroke="#FEA14C" strokeWidth={2} />
                </LineChart>
            </div>

            <div className='flex w-[534px] h-[185px] rounded-[5px] border border-[#6637ed] py-2 px-8 text-[10px] justify-center items-center gap-5'>
    {/* First Column */}
    <div className='flex-1'>
        <div className='flex flex-col gap-2'>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>Temperature:</p>
                <p>{sensorDataQueue.temperature.at(-1) ?? 'N/A'} °C</p>
            </div>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>Pressure:</p>
                <p>{sensorDataQueue.pressure.at(-1) ?? 'N/A'} hPa</p>
            </div>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>Altitude:</p>
                <p>{sensorDataQueue.altitude.at(-1) ?? 'N/A'} m</p>
            </div>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>aX:</p>
                <p>{sensorDataQueue.accelerationX.at(-1) ?? 'N/A'} m/s²</p>
            </div>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>aY:</p>
                <p>{sensorDataQueue.accelerationY.at(-1) ?? 'N/A'} m/s²</p>
            </div>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>aZ:</p>
                <p>{sensorDataQueue.accelerationZ.at(-1) ?? 'N/A'} m/s²</p>
            </div>
        </div>
    </div>

    {/* Second Column */}
    <div className='flex-1'>
        <div className='flex flex-col gap-2'>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>gX:</p>
                <p>{sensorDataQueue.gyroX.at(-1) ?? 'N/A'} °/s</p>
            </div>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>gY:</p>
                <p>{sensorDataQueue.gyroY.at(-1) ?? 'N/A'} °/s</p>
            </div>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>gZ:</p>
                <p>{sensorDataQueue.gyroZ.at(-1) ?? 'N/A'} °/s</p>
            </div>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>Latitude:</p>
                <p>{sensorDataQueue.latitude.at(-1) ?? 'N/A'} °</p>
            </div>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>Longitude:</p>
                <p>{sensorDataQueue.longitude.at(-1) ?? 'N/A'} °</p>
            </div>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>Humidity:</p>
                <p>{sensorDataQueue.humidity.at(-1) ?? 'N/A'} %</p>
            </div>
        </div>
    </div>

    {/* Third Column */}
    <div className='flex-1'>
        <div className='flex flex-col gap-2'>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>Battery:</p>
                <p>{sensorDataQueue.battery.at(-1) ?? 'N/A'} V</p>
            </div>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>Current:</p>
                <p>{sensorDataQueue.current.at(-1) ?? 'N/A'} A</p>
            </div>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>mX:</p>
                <p>{sensorDataQueue.magneticX.at(-1) ?? 'N/A'} µT</p>
            </div>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>mY:</p>
                <p>{sensorDataQueue.magneticY.at(-1) ?? 'N/A'} µT</p>
            </div>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>mZ:</p>
                <p>{sensorDataQueue.magneticZ.at(-1) ?? 'N/A'} µT</p>
            </div>
            <div className='flex justify-between gap-5'>
                <p className='font-bold'>UV:</p>
                <p>{sensorDataQueue.uv.at(-1) ?? 'N/A'} mW/cm²</p>
            </div>
        </div>
    </div>
</div>


            <div className='flex flex-col py-4 bg-[#121212] bg-opacity-60 rounded-[10px] shadow border border-[#6637ed] backdrop-blur-[10px] text-[10px] h-[185px]'>
                    <p className='flex justify-center items-center font-normal text-[10px]'>Magnetic Field</p>
                    <LineChart
                        width={243}
                        height={142}
                        data={combinedMagneticFiledData}
                        margin={{ right: 35, left: 10, top: 12 }}
                    >
                        <XAxis dataKey="time" label={{ value: "Time", position: "outsideBottom", dy: 10 }} stroke='white' />
                        <YAxis
                            label={{ value: "Tesla (T)", angle: -90, position: "insideCenter", dx: -20 }}
                            domain={[-150, 20000]}
                            stroke='white'
                        />
                        <Tooltip
                            contentStyle={{
                                backgroundColor: '#121212',
                                borderColor: '#6637ed',
                                color: 'white',
                                borderRadius: 2
                            }}
                            itemStyle={{
                                color: 'white',
                            }}
                        />
                        <CartesianGrid stroke="#f5f5f5" strokeOpacity={0.1} />
                        <Line type='linear' dataKey="MagneticFieldX" stroke="#4cfe53" strokeWidth={2} />
                        <Line type='linear' dataKey="MagneticFieldY" stroke="#fe4c4c" strokeWidth={2} />
                        <Line type='linear' dataKey="MagneticFieldZ" stroke="#0076ff" strokeWidth={2} />
                    </LineChart>
                </div>

                </div>
            </div>
            </div>

        <div className='flex flex-col text-stone-400 mb-10 font-["Poppins"] text-[12px] text-center'>
            
            <span>© {new Date().getFullYear()} Hex-Star Universe | Website developed & designed by <span className='underline'><a href="https://www.hexstaruniverse.com">Hex-Star Universe</a></span></span>
            
        </div>
        
       
    </div>
  );
}

export default Home;